export const SHIPPING_HANDLING = 10;
